let block_lenght=$('.custom_product_images_bundle').length
for (let oindex = 0; oindex < block_lenght; oindex++) {
  $(`.custom_product_images_bundle .custom_product_images_main_in${oindex}`).flickity({
  prevNextButtons: false,
  pageDots: false,
  draggable: true,
  wrapAround: true,
  freeScroll: false
  });
  let check=$(`.custom_product_images_bundle .custom_product_images_thumb_in${oindex}`).data('length')>4 ? true : false;
$(`.custom_product_images_bundle .custom_product_images_thumb_in${oindex}`).flickity({
  asNavFor: `.custom_product_images_bundle .custom_product_images_main_in${oindex}`,
   contain: true,
  cellAlign: 'center',
  pageDots: false,
  draggable: true,
  // A click that wobbles a few pixels still picks the photo (Flickity's default is 3px, then it counts as a drag).
  dragThreshold: 10,
  wrapAround: false,
  prevNextButtons: false,
  freeScroll: false
});
$(`.custom_product_images_thumb_in${oindex}`).on( 'change.flickity', function( event, index ) {
$(`.custom_product_images_main_in${oindex}`).flickity( 'select', index );
});
}

// Popup images have their own deferred URLs: the main gallery keeps its eager first image.
function rawryLoadPopupImage(carousel) {
  let slider = carousel.data('flickity');
  if (!slider || !carousel.closest('.custom_gallery_popup').hasClass('showing') ||
      !carousel.closest('.gallery_popup_bundle').hasClass('showing')) return;
  let cell = $(slider.selectedElement);
  let image = cell.find('.gallery_popup-wrap_img')[0];
  if (!image) return;

  function ready() {
    cell.removeAttr('aria-busy');
    // A late image may finish after close, an arrow press or a variant change.
    if (!image.naturalWidth || image.getAttribute('src') !== image.dataset.popupSrc ||
        !carousel.closest('.custom_gallery_popup').hasClass('showing') ||
        !carousel.closest('.gallery_popup_bundle').hasClass('showing') ||
        slider.selectedElement !== cell[0] || cell.data('popupZoomReady') || !$.fn.zoom) return;
    cell.data('popupZoomReady', true);
    cell.zoom({ on: 'click', magnify: 2, url: image.dataset.popupSrc, callback: function() {
      $(this).parent().addClass('active');
    }});
  }

  if (image.getAttribute('src')) {
    if (image.complete) ready();
    return;
  }
  cell.attr('aria-busy', 'true');
  $(image).on('load.rawryPopup', ready).on('error.rawryPopup', function() {
    // Retain the same photo at its normal gallery resolution if the zoom copy fails.
    if (image.getAttribute('src') !== image.dataset.popupFallbackSrc) {
      image.src = image.dataset.popupFallbackSrc;
    } else {
      cell.removeAttr('aria-busy');
    }
  });
  image.loading = 'eager';
  image.src = image.dataset.popupSrc;
}

function rawryOpenPopup(popup, index) {
  let carousel = popup.find('.gallery_popup_bundle.showing .gallery_popup_main');
  if (!carousel.length) return;
  let firstOpen = !carousel.data('flickity');
  if (firstOpen) {
    carousel.on('select.flickity.rawryPopup', function() {
      rawryLoadPopupImage($(this));
    }).flickity({
      contain: true,
      pageDots: false,
      draggable: false,
      fade: true,
      initialIndex: Number(index) || 0
    });
  } else {
    carousel.flickity('select', Number(index) || 0, false, true);
  }
  carousel.flickity('resize');
  if (firstOpen) {
    // This slider now starts on open. Finish only its initial height transition so it cannot clip the photo to zero.
    let viewport = carousel.find('.flickity-viewport')[0];
    if (viewport.getAnimations) {
      viewport.getAnimations().forEach(function(animation) {
        if (animation.transitionProperty === 'height') animation.finish();
      });
    }
  }
  rawryLoadPopupImage(carousel);
  carousel.trigger('focus');
}

$(document).on('click','.custom_product_images_bundle.showing .custom_product_images_main .product__photo-zoom',function(e) {
  // Flickity cancels the click at the end of a drag; it must not open the viewer.
  if (e.isDefaultPrevented()) return;
  let popup = $(this).closest('.page-content--product').find('.custom_gallery_popup');
  if (!popup.length) return;
  $('body').addClass('stopscroll');
  popup.addClass('showing');
  rawryOpenPopup(popup, $(this).attr('data-index'));
});

// Arrow keys move the main photos while they are on screen and nothing else has taken the keys (David 2026-09-30).
// A focused carousel or text field keeps its own keys, and the review cards take them only while they are on screen.
document.addEventListener('keydown', function(e) {
  if ((e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
  if ($(document.activeElement).closest('input, select, textarea, [contenteditable], .flickity-enabled, dialog[open]').length) return;
  if ($('.custom_gallery_popup.showing').length) return;
  let main = $('.custom_product_images_bundle.showing .custom_product_images_main');
  if (!main.length || !main.data('flickity')) return;
  let box = main[0].getBoundingClientRect();
  if (box.bottom < window.innerHeight / 3 || box.top > window.innerHeight * 2 / 3) return;
  e.preventDefault();
  main.flickity(e.key === 'ArrowRight' ? 'next' : 'previous');
});

// The sticky site header's height, for style.css: the photo column sticks just below it (David 2026-09-30).
// Only pages with that column measure it: elsewhere each new value restyled the whole page, which made the homepage
// carousel's slide-in jumpy on iPhones (David 2026-10-01).
function rawryHeaderHeight() {
  let header = document.getElementById('shopify-section-header');
  if (header) document.documentElement.style.setProperty('--rawryHeaderHeight', header.offsetHeight + 'px');
}
if (document.querySelector('.product-single__sticky')) {
  rawryHeaderHeight();
  $(window).on('load resize', rawryHeaderHeight);
}
$('.custom_gallery_popup .pswp__button--close').click(function() {
  $(this).parent().removeClass('showing');
  $('body').removeClass('stopscroll');
})


$('.product-single__form .variant-input-wrap input').click(function() {
    hideextraimages($(this));
});
hideextraimages($('.product-single__form .variant-input-wrap input:checked'));

// function hideextraimages(thus){
//       setTimeout(function(){
//     let cvarid = window.location.search.split('=')[1];
//         if(cvarid){
//         }
//         else{
//           cvarid=selectedcurrentvar;
//         }
//     $('.product__quantity--button').attr('data-avalvariant').includes(cvarid)? $('.product__quantity--button').show():$('.product__quantity--button').hide();
//   }, 200);
//   let sum="";
//   thus.parents('.product-single__form').find('input:checked').each(function() {
//     sum+=$(this).attr('data-alt');
//   });
//     let a=thus.attr('data-alt');
//      a=sum;
//   console.log(a,sum)

// thus.parents('.page-content--product').find('.custom_product_gallery_wrapper').find(`.custom_product_images_bundle[data-bundle='${a}']`).addClass('showing').siblings('.custom_product_images_bundle').removeClass('showing');
// thus.parents('.page-content--product').find('.gallery_popup_bundles').find(`.gallery_popup_bundle[data-bundle='${a}']`).addClass('showing').siblings('.gallery_popup_bundle').removeClass('showing');
  
// }

function hideextraimages(thus){

  // 🚫 Stop script if template is "apparel"
  if (document.body.classList.contains('apparel')) {
    return;
  }

  setTimeout(function(){
    let cvarid = window.location.search.split('=')[1];

    if (!cvarid) {
      // selectedcurrentvar is set only on product pages (snippets/product-form.liquid).
      if (typeof selectedcurrentvar === 'undefined') return;
      cvarid = selectedcurrentvar;
    }

    if (
      $('.product__quantity--button')
        .attr('data-avalvariant')
        ?.includes(cvarid)
    ) {
      $('.product__quantity--button').show();
    } else {
      $('.product__quantity--button').hide();
    }

  }, 200);

  let sum = "";

  thus.parents('.product-single__form')
      .find('input:checked')
      .each(function() {
        sum += $(this).attr('data-alt');
      });

  let a = sum;

  thus.parents('.page-content--product')
      .find('.custom_product_gallery_wrapper')
      .find(`.custom_product_images_bundle[data-bundle='${a}']`)
      .addClass('showing')
      .siblings('.custom_product_images_bundle')
      .removeClass('showing');

  thus.parents('.page-content--product')
      .find('.gallery_popup_bundles')
      .find(`.gallery_popup_bundle[data-bundle='${a}']`)
      .addClass('showing')
      .siblings('.gallery_popup_bundle')
      .removeClass('showing');

  // A variant change while the viewer is open initializes only the newly shown set.
  let popup = thus.parents('.page-content--product').find('.custom_gallery_popup.showing');
  if (popup.length) rawryOpenPopup(popup, 0);
}


$(document).ready(function() {
    function initFlickity() {
        $('.page-width.logo__animation_wrapepr .logo-bar').flickity({
            cellAlign: 'center',
            wrapAround: true,
          prevNextButtons: false
        });
    }
    function destroyFlickity() {
        var flkty = $('.page-width.logo__animation_wrapepr .logo-bar').data('flickity');
        if (flkty) {
            flkty.destroy();
        }
    }
    if ($(window).width() < 750) {
        initFlickity();
    }
    $(window).resize(function() {
        if ($(window).width() < 750) {
            initFlickity();
        } else {
            destroyFlickity();
        }
    });
});

$('.product-single__form .variant-input-wrap input').click(function() {
    hidesizeimages($(this));
});
hidesizeimages($('.product-single__form .variant-input-wrap input:checked'));
function hidesizeimages(thus){
      setTimeout(function(){
    let cvarid = window.location.search.split('=')[1];
             if(cvarid){
        }
        else{
          // selectedcurrentvar is set only on product pages (snippets/product-form.liquid).
          if (typeof selectedcurrentvar === 'undefined') return;
          cvarid=selectedcurrentvar;
        }
          $('.our-selected-images div').each(function () {
              if($(this).attr('data-invar').includes(cvarid)){
              $(this).show().siblings().hide()
              } 
          })
  }, 200);
}

$(document).ready(function() {
    $('.rapi-bundles__bar').on('click', function() {
        $('.rapi-bundles__bar').removeClass('active-bundle');
        $(this).addClass('active-bundle');
    });

$(document).ready(function () {
  $('input[type="radio"][name="rapi-bundles-deal"]').change(function () {
    // Get the text content of the price
    var selectedPrice = $(this).siblings('label').find('.rapi-bundles__bar-price').text();

    // Remove currency symbols ($, €, etc.) and keep only the number
    var cleanedPrice = selectedPrice.replace(/[^0-9.,]/g, '');

    // Display the cleaned price
    $('.heee').text(cleanedPrice);
  });
});

});

 

  